import classNames from 'classnames';
import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { useTranslation } from '../../translations';
import { getTotalFileSize, MAX_UPLOAD_SIZE, toMB } from './fil';
import { VedleggFormData } from './vedlegg';

const VedleggIndikator: FC = () => {
    const { vedlegg } = useTranslation();
    const { watch } = useFormContext<VedleggFormData>();
    const maxFileSize = toMB(MAX_UPLOAD_SIZE);
    const combinedFilesSize = getTotalFileSize(watch());
    const statusWidth = (combinedFilesSize / maxFileSize) * 100;

    return (
        <div className="vedlegg-indikator">
            <div className="indikator-bar">
                <div
                    className={classNames('indikator-bar--status', { 'indikator-bar--status-max': statusWidth >= 100 })}
                    style={{ width: `${statusWidth}%` }}
                />
            </div>
            <div className="status-bar">
                <div>{`${vedlegg.infoTotalt} ${combinedFilesSize} ${vedlegg.infoMegabyte}`}</div>
                <div>{`${maxFileSize} ${vedlegg.infoMegabyte}`}</div>
            </div>
        </div>
    );
};

export default VedleggIndikator;
